<template>
  <div class="results-container">

    <!-- Dekorasi pojok -->
    <div class="deco deco--tl" aria-hidden="true">
      <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="50" fill="#4489C6" opacity="0.12"/>
        <circle cx="10" cy="10" r="20" fill="#6DD5FA" opacity="0.18"/>
      </svg>
    </div>
    <div class="deco deco--br" aria-hidden="true">
      <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="90" cy="90" r="55" fill="#F0D25B" opacity="0.15"/>
        <circle cx="110" cy="110" r="22" fill="#DF654D" opacity="0.12"/>
      </svg>
    </div>

    <div class="card-content">

      <!-- Resume notice banner — tampil saat user belum memilih jurusan kunjungan -->
      <div v-if="isResumeMode" class="resume-notice">
        <div class="resume-notice__mascot">
          <img src="@/assets/pcu/2026/abby-smile-half.png" alt="Abby" class="resume-notice__img" />
        </div>
        <div class="resume-notice__content">
          <p class="resume-notice__title">Hai{{ nickname ? ', ' + nickname : '' }}! Hampir sampai! 🎉</p>
          <p class="resume-notice__body">
            Hasil tesmu sudah siap — tapi ada satu langkah kecil yang terlewat.
            Kamu belum memilih <strong>jurusan yang akan dikunjungi</strong> di Petra Parade 2026.
            Yuk, pilih salah satu di bawah supaya barcode absen kamu bisa langsung tampil! 🎫
          </p>
        </div>
      </div>
      <!-- <div class="abby-header">
        <div class="abby-mascot">
          <img src="@/assets/pcu/2026/abby-smile-half.png" alt="Abby Mascot" class="abby-img" />
        </div>
        <div class="abby-dialog">
          <p class="greeting-title">Yeay! Surveynya selesai! 🎉</p>
          <p class="greeting-body" v-html="greetingMessage"></p>
        </div>
      </div> -->

      <!-- Pilihan awal user -->
      <!-- <div v-if="hasSelections || hasExtras" class="section">
        <h3 class="section-title">PILIHAN JURUSANMU</h3>
        <div class="chips-wrap">
          <span v-for="id in selectedProdis" :key="id" class="chip chip--petra">
            🎓 {{ prodiList[id] || id }}
          </span>
          <span v-for="(item, i) in extraProdis" :key="'extra-' + i" class="chip chip--custom">
            ✏️ {{ prodiList[item] || item }}
          </span>
        </div>
      </div> -->

      <!-- Hasil tes - Priority Program saja -->
      <div v-if="hasTestResult" class="result-card result-card--priority">
        <h3 class="result-card-label">Rekomendasi Jurusan Sesuai Hasil Tes Kamu</h3>
        <div class="priority-row">
          <div class="priority-icon-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="priority-star">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
            </svg>
          </div>
          <span class="priority-name">{{ results.priority_program }}</span>          
          <!-- <span class="priority-badge">Top Match</span> -->
        </div>
        <div v-if="results.priority_program2" class="priority-row">
          <div class="priority-icon-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="priority-star">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
            </svg>
          </div>
          <span class="priority-name">{{ results.priority_program2 }}</span>          
          <!-- <span class="priority-badge">Top Match</span> -->
        </div>
      </div>

      <!-- Pilihan kunjungan (required) -->
      <div class="result-card result-card--choice">
        <h3 class="result-card-label">Pilih Jurusan yang Akan Kamu Kunjungi</h3>
        <div class="choice-header">
          <p class="choice-subtitle">Pilih <strong>1 jurusan</strong> yang paling ingin kamu explore pertama di Petra Parade 2026!</p>
          <button
            class="btn-toggle-all"
            :class="{ active: showAllDesc }"
            @click="showAllDesc = !showAllDesc"
          >{{ showAllDesc ? '▴ Sembunyikan' : '▾ Lihat semua keterangan' }}</button>
        </div>
        <div class="choice-list">
          <div
            v-for="item in results.choice_program"
            :key="item.id"
            class="choice-item-wrap"
          >
            <button
              class="choice-item"
              :class="{
                selected: chosenProgram === item.id,
                'desc-open': visibleDesc === item.id || showAllDesc
              }"
              @click="selectProgram(item.id)"
            >
              <span class="choice-radio">
                <span v-if="chosenProgram === item.id" class="radio-filled"></span>
              </span>
              <span class="choice-name">{{ item.nama }}</span>
            </button>
            <Transition
              @before-enter="onDescBeforeEnter"
              @enter="onDescEnter"
              @after-enter="onDescAfterEnter"
              @before-leave="onDescBeforeLeave"
              @leave="onDescLeave"
              @after-leave="onDescAfterLeave"
            >
              <div
                v-if="visibleDesc === item.id || showAllDesc"
                class="choice-desc"
                :class="{ 'choice-desc--selected': chosenProgram === item.id }"
              >{{ item.penjelasan }}</div>
            </Transition>
          </div>
        </div>
      </div>

      <!-- Tombol Selesai -->
      <button
        class="btn-finish"
        :class="{ 'btn-finish--ready': chosenProgram !== null && !isSubmitting }"
        :disabled="chosenProgram === null || isSubmitting"
        @click="handleFinish"
      >
        <svg v-if="isSubmitting" class="btn-icon btn-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/>
        </svg>
        <svg v-else-if="chosenProgram !== null" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="btn-icon">
          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
        </svg>
        <span>{{ isSubmitting ? 'Menyimpan pilihan...' : (chosenProgram !== null ? 'Selesai! Lihat Hasilmu 🎉' : 'Pilih dulu satu program di atas') }}</span>
      </button>

    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useToast } from '../composables/useToast';

const { addToast } = useToast();

const props = defineProps({
  results: { type: Object, required: true },
  selectedProdis: { type: Array, default: () => [] },
  extraProdis: { type: Array, default: () => [] },
  prodiList: { type: Object, default: () => ({}) },
  nickname: { type: String, default: '' },
  isResumeMode: { type: Boolean, default: false }
});

const emit = defineEmits(['finish']);

const chosenProgram = ref(null);  // submitted value — updates immediately
const visibleDesc = ref(null);    // which desc panel is rendered — sequential
const pendingDesc = ref(null);    // next desc to open after current closes
const isSubmitting = ref(false);
const showAllDesc = ref(false);

function selectProgram(id) {
  if (showAllDesc.value) {
    // In show-all mode all panels are visible via showAllDesc, no animation runs.
    // Still sync visibleDesc so when show-all is turned off the correct panel stays open.
    chosenProgram.value = id;
    visibleDesc.value = id;
    return;
  }
  if (chosenProgram.value === id) return; // already selected
  chosenProgram.value = id; // radio switches instantly
  if (visibleDesc.value === null) {
    // Nothing open — open immediately
    visibleDesc.value = id;
  } else {
    // Something is open — queue the new one, close the current
    pendingDesc.value = id;
    visibleDesc.value = null;
  }
}

// ---- Smooth accordion JS hooks ----
function onDescBeforeEnter(el) {
  el.style.height = '0';
  el.style.opacity = '0';
  el.style.transform = 'translateY(-4px)';
  el.style.overflow = 'hidden';
}
function onDescEnter(el, done) {
  const targetH = el.scrollHeight;
  el.style.transition = 'height 0.28s cubic-bezier(0.4,0,0.2,1), opacity 0.22s ease, transform 0.25s ease';
  // Force reflow
  void el.offsetHeight;
  el.style.height = targetH + 'px';
  el.style.opacity = '1';
  el.style.transform = 'translateY(0)';
  el.addEventListener('transitionend', done, { once: true });
}
function onDescAfterEnter(el) {
  el.style.height = '';
  el.style.overflow = '';
  el.style.transition = '';
  el.style.transform = '';
}
function onDescBeforeLeave(el) {
  el.style.height = el.scrollHeight + 'px';
  el.style.overflow = 'hidden';
}
function onDescLeave(el, done) {
  el.style.transition = 'height 0.22s cubic-bezier(0.4,0,0.2,1), opacity 0.18s ease, transform 0.2s ease';
  void el.offsetHeight;
  el.style.height = '0';
  el.style.opacity = '0';
  el.style.transform = 'translateY(-4px)';
  el.addEventListener('transitionend', done, { once: true });
}
function onDescAfterLeave(el) {
  el.style.height = '';
  el.style.overflow = '';
  el.style.transition = '';
  el.style.opacity = '';
  el.style.transform = '';
  // Open the pending description now that the previous one has fully closed
  if (pendingDesc.value !== null) {
    visibleDesc.value = pendingDesc.value;
    pendingDesc.value = null;
  }
}

async function handleFinish() {
  if (chosenProgram.value === null || isSubmitting.value) return;
  isSubmitting.value = true;
  try {
    const apiUrl = `${process.env.VUE_APP_API_URL}/prodiVisit`;
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        student_id: props.results.student?.id,
        program_id: chosenProgram.value
      })
    });
    if (!response.ok) throw new Error(`Status: ${response.status}`);
    const data = await response.json();
    if (data.data.success) {
      emit('finish', {
        prodiId: chosenProgram.value,
        prodiName: props.results.choice_program?.find(p => p.id === chosenProgram.value)?.nama,
        barcodeCode: props.results.student?.barcode
      });
    } else {
      addToast(data.message || 'Gagal menyimpan pilihan.', 'error');
    }
  } catch (err) {
    addToast('Gagal menyimpan pilihan. Periksa koneksi dan coba lagi.', 'error');
  } finally {
    isSubmitting.value = false;
  }
}

const hasSelections = computed(() => props.selectedProdis.length > 0);
const hasExtras = computed(() => props.extraProdis.length > 0);
const hasTestResult = computed(() => !!props.results.priority_program);

const selectedProdiNames = computed(() =>
  props.selectedProdis.map(id => props.prodiList[id]).filter(Boolean)
);

const priorityMatchesSelection = computed(() => {
  const p = props.results.priority_program?.toLowerCase() ?? '';
  return selectedProdiNames.value.some(n => n.toLowerCase() === p);
});

// eslint-disable-next-line no-unused-vars
const greetingMessage = computed(() => {
  const hasS = hasSelections.value;
  const hasE = hasExtras.value;
  const hasT = hasTestResult.value;
  const priority = props.results.priority_program;
  const name = props.nickname || props.results.student?.name?.split(' ')[0] || '';
  const hey = name ? `<strong>${name}</strong>, ` : '';

  if (!hasS && !hasE && !hasT) {
    return `Hei ${hey}kamu melewati semua pilihan dan tes — gak apa-apa kok! Ini saatnya kamu mulai explore. Pilih <strong>1 program</strong> yang paling bikin kamu penasaran dari daftar di bawah ya! 😊`;
  }
  if (!hasS && !hasE && hasT) {
    return `Hei ${hey}dari hasil tesmu, kamu cocok banget dengan <strong>${priority}</strong>! Wah keren 🤩 Yuk, explore lebih lanjut dengan mengunjungi stand-nya di Petra Parade 2026!`;
  }
  if (hasS && !hasE && !hasT) {
    return `Hei ${hey}kamu sudah punya program incaran — mantap! Yuk explore lebih jauh di Petra Parade 2026. Pilih <strong>1 program</strong> yang paling ingin kamu kunjungi duluan! 🎯`;
  }
  if (hasS && !hasE && hasT) {
    if (priorityMatchesSelection.value) {
      return `Hei ${hey}pilihanmu <strong>selaras banget</strong> dengan hasil tesmu — kamu cocok dengan <strong>${priority}</strong>. Udah mantab nih! Yuk, langsung explore di Petra Parade! 🏆`;
    }
    return `Hei ${hey}kamu punya program incaran, dan hasil tesmu juga menunjukkan kamu cocok dengan <strong>${priority}</strong>. Menarik kan? Pilih satu yang paling ingin kamu explore duluan! 🔍`;
  }
  if (!hasS && hasE && !hasT) {
    return `Hei ${hey}kamu berminat dengan jurusan di luar UK Petra ya. Keren! Coba juga lihat program-program UK Petra di bawah — siapa tau ada yang cocok buatmu! 😉`;
  }
  if (!hasS && hasE && hasT) {
    return `Hei ${hey}kamu berminat dengan jurusan di luar UK Petra, tapi hasil tesmu menunjukkan kamu juga bisa cocok dengan <strong>${priority}</strong> yang ada di UK Petra lho! Mau explore? 🎓`;
  }
  // hasS && hasE (dengan atau tanpa test)
  if (hasT) {
    return `Hei ${hey}banyak pilihan nih! Hasil tesmu juga menunjukkan kamu cocok dengan <strong>${priority}</strong>. Yuk pilih <strong>1 program</strong> yang paling ingin kamu kunjungi duluan! 🎉`;
  }
  return `Hei ${hey}kamu sudah punya banyak pilihan! Sekarang pilih <strong>1 program</strong> yang paling ingin kamu kunjungi di Petra Parade 2026. Semangat! 💪`;
});
</script>

<style scoped>
/* ---- Resume notice banner ---- */
.resume-notice {
  display: flex;
  align-items: flex-end;
  gap: 0.85rem;
  background: linear-gradient(135deg, #fff8f5, #fff3ee);
  border: 1.5px solid #f5c4b3;
  border-left: 4px solid #DF654D;
  border-radius: 18px;
  padding: 1rem 1.1rem 0.75rem 0.85rem;
  animation: pop-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;
}

.resume-notice__mascot {
  flex-shrink: 0;
}

.resume-notice__img {
  width: 70px;
  object-fit: contain;
  display: block;
  animation: float-abby 3s ease-in-out infinite;
  -webkit-mask-image: linear-gradient(to bottom, black 85%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 85%, transparent 100%);
}

.resume-notice__content {
  flex: 1;
}

.resume-notice__title {
  font-size: 0.92rem;
  font-weight: 800;
  color: #c44a2d;
  margin: 0 0 0.35rem;
  line-height: 1.25;
}

.resume-notice__body {
  font-size: 0.78rem;
  color: #6b3020;
  line-height: 1.6;
  margin: 0;
}

.resume-notice__body strong {
  color: #DF654D;
  font-weight: 700;
}

/* ---- Container ---- */
.results-container {
  background: #ffffff;
  border-radius: 28px;
  padding: 2.5rem;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.12);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.7);
  font-family: 'Epilogue', sans-serif;
  animation: card-in 0.5s cubic-bezier(0.25, 0.8, 0.25, 1) both;
}

@keyframes card-in {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Corner deco */
.deco {
  position: absolute;
  pointer-events: none;
  z-index: 0;
  width: 120px;
  height: 120px;
}
.deco--tl { top: -30px; left: -30px; }
.deco--br { bottom: -30px; right: -30px; }

.card-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

/* ---- Abby Header ---- */
.abby-header {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 12px;
}

.abby-mascot {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.abby-img {
  width: 130px;
  object-fit: contain;
  animation: float-abby 3s ease-in-out infinite;
  -webkit-mask-image: linear-gradient(to bottom, black 88%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 88%, transparent 100%);
  display: block;
}

@keyframes float-abby {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-6px); }
}

.abby-dialog {
  background: #EFF6FF;
  border: 2px solid #26488A;
  border-radius: 16px 16px 16px 0;
  padding: 0.8rem 1rem;
  max-width: 300px;
  text-align: left;
  font-size: 0.85rem;
  line-height: 1.55;
  color: #1e3a6e;
  box-shadow: 4px 4px 0 #26488A;
  animation: pop-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s both;
  position: relative;
}

/* Tail outer */
.abby-dialog::before {
  content: '';
  position: absolute;
  bottom: -18px;
  left: -2px;
  border: 8px solid transparent;
  border-top-color: #26488A;
  border-bottom: none;
  border-left: none;
}
/* Tail inner */
.abby-dialog::after {
  content: '';
  position: absolute;
  bottom: -13px;
  left: 0;
  border: 7px solid transparent;
  border-top-color: #EFF6FF;
  border-bottom: none;
  border-left: none;
}

@keyframes pop-in {
  from { opacity: 0; transform: scale(0.85) translateY(8px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.greeting-title {
  font-weight: 800;
  font-size: 0.95rem;
  margin: 0 0 0.35rem;
  color: #26488A;
}
.greeting-body {
  margin: 0;
  font-size: 0.82rem;
}

/* ---- Pilihan awal section ---- */
.section {
  background: #f8fafc;
  border-radius: 16px;
  padding: 1rem 1.1rem;
}

.section-title {
  font-size: 0.7rem;
  font-weight: 900;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #7d95b0;
  margin: 0 0 0.7rem;
}

.chips-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.85rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

.chip--petra {
  background: #EFF6FF;
  border: 1.5px solid #26488A;
  color: #1e3a6e;
}

.chip--custom {
  background: #fff9ec;
  border: 1.5px solid #F0D25B;
  color: #7a5200;
}

/* ---- Result Cards (light theme) ---- */
.result-card {
  border-radius: 20px;
  padding: 1.1rem 1.25rem;
}

.result-card-label {
  font-size: 0.68rem;
  font-weight: 900;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin: 0 0 0.75rem;
}

/* Priority card — warm gold */
.result-card--priority {
  background: linear-gradient(135deg, #fffdf4, #fff8e0);
  border: 1.5px solid #f0d25b;
}

.result-card--priority .result-card-label {
  color: #a07c10;
}

.priority-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 7px;
}

.priority-icon-wrap {
  width: 36px;
  height: 36px;
  background: #F0D25B;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.priority-star {
  width: 18px;
  height: 18px;
  fill: #5a3d00;
}

.priority-name {
  font-weight: 800;
  font-size: 0.95rem;
  color: #1e3a6e;
  flex: 1;
  line-height: 1.3;
}

.priority-badge {
  font-size: 0.68rem;
  font-weight: 700;
  background: #F0D25B;
  color: #5a3d00;
  padding: 0.22rem 0.65rem;
  border-radius: 20px;
  white-space: nowrap;
}

/* Choice card — light neutral */
.result-card--choice {
  background: #f8fafc;
  border: 1.5px solid #dee8f5;
}

.result-card--choice .result-card-label {
  color: #7d95b0;
}

/* ---- Choice list ---- */
/* ---- Choice header row ---- */
.choice-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.6rem;
  margin-bottom: 0.85rem;
}

.choice-subtitle {
  font-size: 0.8rem;
  color: #5a7a9a;
  margin: 0;
  line-height: 1.5;
  flex: 1;
}

.btn-toggle-all {
  background: #EFF6FF;
  border: 1.5px solid #cce0f5;
  border-radius: 20px;
  color: #26488A;
  font-size: 0.68rem;
  font-weight: 700;
  font-family: inherit;
  padding: 0.25rem 0.65rem;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  line-height: 1.6;
}

.btn-toggle-all:hover {
  background: #d8ecff;
  border-color: #4489C6;
}

.btn-toggle-all.active {
  background: #26488A;
  color: #ffffff;
  border-color: #26488A;
}

.choice-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* ---- Choice item wrap ---- */
.choice-item-wrap {
  display: flex;
  flex-direction: column;
}

.choice-item {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: #ffffff;
  border: 1.5px solid #d8e6f5;
  color: #2c4a6e;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: background 0.18s, border-color 0.18s, transform 0.15s;
  box-shadow: 0 1px 4px rgba(38, 72, 138, 0.06);
}

.choice-item:hover {
  border-color: #4489C6;
  background: #f0f5ff;
  color: #1e3a6e;
}

.choice-item.selected {
  background: #26488A;
  border-color: #26488A;
  color: #ffffff;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(38, 72, 138, 0.25);
}

.choice-item:active {
  transform: scale(0.98);
}

.choice-item.desc-open {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-color: transparent;
}

.choice-item.selected.desc-open {
  border-bottom-color: transparent;
}

/* ---- Description panel ---- */
.choice-desc {
  padding: 0.65rem 1rem 0.7rem;
  background: #f3f7ff;
  border: 1.5px solid #d8e6f5;
  border-top: none;
  border-radius: 0 0 12px 12px;
  font-size: 0.78rem;
  color: #2c4a6e;
  line-height: 1.65;
}

.choice-desc--selected {
  background: #e8f0fe;
  border-color: #26488A;
  color: #1a327a;
}

/* ---- Desc expand animation — handled via JS hooks ---- */

.choice-radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #b8cfe8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.18s;
}

.choice-item.selected .choice-radio {
  border-color: rgba(255, 255, 255, 0.5);
}

.radio-filled {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #F0D25B;
}

.choice-name {
  flex: 1;
}

/* ---- Finish button ---- */
.btn-finish {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 1rem;
  border-radius: 16px;
  border: none;
  background: #d0d8e8;
  color: #7a8aaa;
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: not-allowed;
  transition: background 0.3s, color 0.3s, transform 0.2s, box-shadow 0.2s;
}

.btn-finish--ready {
  background: linear-gradient(135deg, #DF654D, #c94f3a);
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(223, 101, 77, 0.4);
}

.btn-finish--ready:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(223, 101, 77, 0.55);
}

@keyframes spin-btn {
  to { transform: rotate(360deg); }
}
.btn-spinner {
  animation: spin-btn 0.9s linear infinite;
}

.btn-finish--ready:active {
  transform: scale(0.98);
}

.btn-icon {
  width: 18px;
  height: 18px;
  fill: currentColor;
  flex-shrink: 0;
}

/* ---- Responsive ---- */
@media (max-width: 480px) {
  .results-container {
    padding: 1.75rem 1.25rem;
  }

  .abby-img {
    width: 100px;
  }

  .abby-dialog {
    max-width: 230px;
  }
}
</style>